<template>
    <div class="col-md-12">
        <div class="row mb-2" v-for="(item, index) in emails">
            <div class="col-md-10 col-sm-10 col-xs-10">
                <input type="email" @change="checkEmail(item, index)" class="form-control" :id="name" :name="`${name}[]`" placeholder="Type email"
                       v-model="item.email">
            </div>
            <div class="col-md-2 col-sm-2 col-xs-2"><span style="cursor: pointer" title="Remove Email" @click="deleteLine(index)"
                                        class="fa fa-times text-danger"></span></div>
        </div>
        <span style="cursor: pointer" title="Add Email" @click="addEmail('')" class="fa fa-plus text-green"></span>

    </div>

</template>

<script>
export default {
    name: "EmailVetorial",
    props: {

        name: {
            type: String,
            default: 'emails'
        },
    },
    data() {
        return {
            emails: [],
        }
    },
    mounted() {
        if (!this.emails.length) {
            this.addEmail("")

        }
    },
    methods: {
        addEmail(email) {
            this.emails.push({
                email: email
            })
        },
        deleteLine(itemIndex) {
            this.emails.splice(itemIndex, 1);

        },
        addFirstEmail(email) {
            if (!this.emails.length) {
                this.addEmail(email)
            } else {
                this.emails[0] = {
                    email: email
                }
            }

            this.$forceUpdate()
        },
        checkEmail(item, index) {
            let validationResult = this.validateEmail(item.email)
            if (!validationResult.valid) {
                showMessage('e',validationResult.message);
                this.emails[index] =  {
                    email: ""
                }
            }
        },
        validateEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!email) {
                return {valid: false, message: "Email address is required."};
            } else if (!emailRegex.test(email)) {
                return {valid: false, message: "Invalid email address format."};
            } else {
                return {valid: true, message: "Email address is valid."};
            }
        }
    }

}
</script>

<style scoped>

</style>
